export enum SortMenuItemDirection {
    ASC = '+',
    DESC = '-',
}
